import {useQuery} from 'react-query';
import {getPostReport} from '../../../services/post';

const useGetPostReport = (id: string) => {
  const {data: report, isLoading} = useQuery(['PostReport', id], getPostReport);

  return {report, isLoading};
};

export default useGetPostReport;
